export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/drone_videography.0874929.svg";